import React from 'react';
import { Pagination } from '../../components/common/Pagination';

const PaginationComponent = (props) => {
    const modules=["Order","Quotation"]
    const { count, setCount, currentPage, filteredResults, pageSize, setCurrentPage, moduleName } = props;
    const startEntry = (currentPage - 1) * count + 1;
    const endEntry = Math.min(currentPage * count, modules?.includes(moduleName) ? filteredResults?.totalRecords : filteredResults.length);

    return (
        <>
            {/* pagination-sec start */}
            <div className='row pagination-row'>
                <div className='col-md-12'>
                    <div className='card'>
                        <div className='card-body'>
                            <div className='pagination-d-flex justify-content-center justify-content-md-between'>
                                <div className='d-flex align-items-baseline'>
                                    <p className='mr-2'>Show</p>
                                    <select
                                        id={`${moduleName || "list"}-page-size`}
                                        name={`${moduleName || "list"}PageSize`}
                                        className='form-control mr-2'
                                        value={count}
                                        onChange={e => setCount(Number(e.target.value))}
                                    >
                                        {[25, 50, 100].map(Count => (
                                            <option key={Count} value={Count}>{Count}</option>))
                                        }
                                    </select>
                                    <p>{startEntry} - {endEntry} of {modules?.includes(moduleName) ? filteredResults?.totalRecords : filteredResults.length} Entries</p>
                                </div>
                                <nav aria-label="Page navigation example" className='lg:ml-4'>
                                    <Pagination
                                        className="pagination-bar pl-0"
                                        currentPage={currentPage}
                                        totalCount={modules?.includes(moduleName) ? filteredResults?.totalRecords : filteredResults.length}
                                        pageSize={pageSize}
                                        onPageChange={page => setCurrentPage(page)} />
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* pagination-sec end */}
        </>
    )
}

export default PaginationComponent